import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { setFrequencyOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientMedicationsService } from '../../patientMedications/services/patientMedications.service'

export function* getFrequencyOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientMedicationService = new PatientMedicationsService(serviceId)
  try {
    const FrequencyResponse: IOptionsResponse = yield call([
      patientMedicationService,
      patientMedicationService.getFrequencyOptions,
    ])
    const { entity } = FrequencyResponse
    yield put(setFrequencyOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getFrequencyOptions() error: ${e}`))
  }
}

export function* getFrequencyOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getFrequencyOptions)
}
